import '~/js/modules/stickyNav';
import Accomodations from '~/js/views/resorts/components/Accomodations';

import '~/js/views/resorts/includes/scroll-below';

const internals = {
    filters: {
        roomCategories: ['PG', 'LX', 'PR', 'DL', 'PO', 'HB', 'GO', 'GC', 'HP1', 'P1']
    }
};

const reactAccomodations = document.querySelector('#rct-accomodations');

ReactDOM.render(<Accomodations filters={internals.filters} />, reactAccomodations);
